<template>
  <div class="detail_box">
    <div class="detail_box_top">
      <div class="detail_box_top_title">{{ boardData.wr_subject }}</div>
      <div class="detail_box_top_date">{{ returnDate(boardData.created_at) }}</div>
    </div>
    <div class="detail_box_center">
      <div class="detail_box_center_content" v-html="boardData.wr_content"></div>
    </div>
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";

export default {
  name: "BoardDetailDefaultLayout",
  mixins: [imageOption],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    boardData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage(board) {
      if (!util.isEmpty(board.File.MobileFile[0])) {
        return `${board.File.MobileFile[0].org_url}?${this.setImageOptions(316, 316, 'jpg')}`;
      }
    },
    goDetail(idx) {
      this.$router.push(`/album/${idx}`)
    },
    returnDate(date = null) {
      if (!date) {
        return '';
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm')
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>